import { Component, computed, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { DateService } from 'src/app/services/date/date.service';
import { requestInterface } from 'src/app/util/interfaces/request';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';

@Component({
	selector: 'pcp-request-page-tab-inconsistency',
	standalone: true,
	imports: [RouterModule, FontAwesomeModule],
	templateUrl: './request-page-tab-inconsistency.component.html',
	styleUrl: './request-page-tab-inconsistency.component.scss',
})
export class RequestPageTabInconsistencyComponent {
	private readonly labelsService = inject(LabelsService);
	public readonly permissionService = inject(PermissionService);
	public readonly dateService = inject(DateService);

	icons = {
		faExternalLinkAlt: faExternalLinkAlt,
	};

	@Input() requestData: requestInterface;
	@Input() labels: LabelsInterface;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}
}
